module.exports = __webpack_public_path__ + "static/media/clients.a278748d.png";